module.exports = __webpack_public_path__ + "img/1791982325823.936a3e66.png";